import { AfterViewInit, Directive, ElementRef, HostListener, Input, OnChanges, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { ScriptLoaderService } from 'helpers/services/script-loader.service';
import { UserInfo } from 'core/authentication/user-information';
import { AccessHelper } from 'helpers/access.helper';
import { HttpClient } from '@angular/common/http';
import { DisabledHelper } from 'helpers/disabled-helper';

declare let $: any;

@Directive({
  selector: '[customdisabled]'
})
export class CustomDisabledDirective implements OnInit, OnChanges {
  @Input() customdisabled: any;

  constructor(private http: HttpClient, private el: ElementRef) {

  }

  ngOnInit (): any {
    this.ngOnChanges();
  }

  ngOnChanges (): any {
    if (this.customdisabled === 'disabled' || this.customdisabled === true) {
      DisabledHelper.disableInputElement(this.el.nativeElement, 'customdisabled');
    } else {
      DisabledHelper.enableInputElement(this.el.nativeElement, 'customdisabled');
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/helpers/directives/customdisabled/customdisabled.directive.ts